import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.addEventListener("turbo:load", () => {
      AOS.init({
        duration: 800,
        once: true
      })
    })
  }
}
